import React, { useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound, Mail, CheckCircle2, AlertCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Tx } from "../context/AutoTranslateContext";

const ForgotPassword = () => {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    const r = await forgotPassword(email);
    setBusy(false);
    if (r.ok) setSent(true); else setError(r.error);
  };

  return (
    <div data-testid="forgot-page" className="max-w-md mx-auto px-4 py-16">
      <div className="bg-white rounded-3xl border border-gold/25 p-8 shadow-sm">
        <div className="text-center mb-6">
          <div className="inline-flex w-12 h-12 rounded-full bg-forest/10 text-forest items-center justify-center mb-3">
            <KeyRound className="w-5 h-5" />
          </div>
          <h1 className="font-heading text-3xl text-forest font-bold mb-2"><Tx>Reset your password</Tx></h1>
          <p className="text-sm text-mute"><Tx>Enter your email and we'll send you a reset link.</Tx></p>
        </div>

        {sent ? (
          <div data-testid="forgot-sent" className="flex items-start gap-2 text-sm text-forest bg-forest/10 rounded-2xl p-4">
            <CheckCircle2 className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <span><Tx>If an account exists for that email, a reset link has been sent. Please check your inbox.</Tx></span>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <label className="block">
              <span className="text-xs uppercase tracking-widest text-mute"><Tx>Email</Tx></span>
              <div className="mt-1.5 relative">
                <Mail className="w-4 h-4 text-mute absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  data-testid="forgot-email" type="email" autoComplete="email" required
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 rounded-full bg-cream border border-forest/10 text-ink outline-none focus:border-forest transition"
                />
              </div>
            </label>
            {error && (
              <div data-testid="forgot-error" className="flex items-start gap-2 text-sm text-clay bg-clay/10 rounded-2xl p-3">
                <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>{error}</span>
              </div>
            )}
            <button
              data-testid="forgot-submit"
              type="submit" disabled={busy}
              className="w-full py-3 rounded-full bg-forest text-sand hover:bg-sage transition font-medium disabled:opacity-60"
            >
              {busy ? <Tx>Sending…</Tx> : <Tx>Send reset link</Tx>}
            </button>
          </form>
        )}

        <p className="mt-5 text-center text-xs text-mute">
          <Link data-testid="link-back-login" to="/login" className="text-forest hover:underline"><Tx>Back to sign in</Tx></Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
